module.exports = __webpack_public_path__ + "img/Weapon_177.c1fca21f.png";